import { fetchImportTemplateFieldMappingService } from "../data/importTemplateFieldMappingService";
import { fetchItemLookupColumns } from "../../items/data/importExportItemsService";
import { fetchItemLookupCustomAttributes } from "../../items/data/itemLookupService";
import { fetchItemLookupTypeCustomAttributes } from "../../items/data/itemLookupTypeService";

  export const getMapToSourceData = async () => {
    const importTemplateFieldMapping = await fetchImportTemplateFieldMappingService();

    const itemLookupHeaders = await fetchItemLookupColumns();
    const mappedItemLookupHeaders =
      itemLookupHeaders?.map((header) => ({ fieldName: header.label })) ?? [];

    const itemLookupCustomAttributes = await fetchItemLookupCustomAttributes();
    const mappedItemLookupCustomAttributes =
      itemLookupCustomAttributes?.map((customAttribute) => ({ fieldName: customAttribute })) ?? [];

    const itemLookupTypeCustomAttributes = await fetchItemLookupTypeCustomAttributes();
    const mappedItemLookupTypeCustomAttributes =
      itemLookupTypeCustomAttributes?.map((customAttribute) => ({ fieldName: customAttribute })) ?? [];

    const sourceData = [
      ...(importTemplateFieldMapping ?? []),
      ...mappedItemLookupHeaders,
      ...mappedItemLookupCustomAttributes,
      ...mappedItemLookupTypeCustomAttributes
    ];
    return sourceData.sort((a, b) => a.fieldName.localeCompare(b.fieldName));
  };